import styled from "styled-components";
export const PaginationContainer = styled.div`
    text-align: right;
    margin-top: 20px;
    .pagination {
    margin: 0;
    > .active > button,
    > .active > span,
    > .active > button:hover,
    > .active > span:hover,
    > .active > button:focus,
    > .active > span:focus {
      background-color: var(--color-primary);
      border-color: var(--color-primary);
      color: white;
    }
    > li > button,
    > li > span {
      color: var(--color-primary);
      border-color: gray;
      outline: none;
      border: none;
      padding: 5px 10px;
      float: none;
    }
    > li {
        display: inline-block;
    }
    > li > button:hover,
    > li > span:hover,
    > li > button:focus,
    > li > span:focus {
      color: white;
      background-color: var(--color-primary);
      border-color: var(--color-primary);
    }
  }
`;
